import type { TOC } from '@ember/component/template-only';
import t from 'ember-intl/helpers/t';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}
export default <template>
  <@form.FieldsRadioGroup
    @propertyName='transitBlockage'
    @title={{t 'mici-form.transitBlockage.long' htmlSafe=true}}
    as |Group|
  >
    <Group.FieldRadio @value={{true}} @label='Oui' />
    <Group.FieldRadio @value={{false}} @label='Non' />
  </@form.FieldsRadioGroup>
</template> satisfies TOC<Signature>;
